import dynamic from 'next/dynamic';

export const Form = dynamic(() => import('./Form'), { ssr: true });
